import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { initAnalytics, trackPageView } from "@/lib/analytics";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import Resources from "@/pages/Resources";
import Article from "@/pages/Article";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Assessment from "@/pages/Assessment";
import StateTierII from "@/pages/StateTierII";
import Legal from "@/pages/Legal";
import TrustSecurity from "@/pages/TrustSecurity";
import HowItWorks from "@/pages/HowItWorks";
import ForConsultants from "@/pages/ForConsultants";
import Login from "@/pages/Login";
import Dashboard from "@/pages/admin/Dashboard";
import ProtectedRoute from "@/components/ProtectedRoute";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => { initAnalytics(); }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RouteTracker />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/industries/:slug" element={<IndustryDetail />} />
              <Route path="/resources" element={<Resources />} />
              <Route path="/resources/:slug" element={<Article />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/free-tier-ii-assessment" element={<Assessment />} />
              <Route path="/request-a-quote" element={<Assessment />} />
              <Route path="/for-consultants" element={<ForConsultants />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/trust-security" element={<TrustSecurity />} />
              <Route path="/tier-ii-reporting/:state" element={<StateTierII />} />
              <Route path="/privacy" element={<Legal type="privacy" />} />
              <Route path="/terms" element={<Legal type="terms" />} />
              <Route path="/disclaimer" element={<Legal type="disclaimer" />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
